import { render, staticRenderFns } from "./UserMoney.vue?vue&type=template&id=a4be8f42&scoped=true"
import script from "./UserMoney.vue?vue&type=script&lang=js"
export * from "./UserMoney.vue?vue&type=script&lang=js"
import style0 from "./UserMoney.vue?vue&type=style&index=0&id=a4be8f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4be8f42",
  null
  
)

export default component.exports